import React from "react";
import { dateValue, SectionTitle } from "../EmployeeForm";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { Button } from "../../../ui/buttons";
import { Plus, Trash2 } from "lucide-react";
import { toIST } from "../../../utils/calculateMargin";

function WorkExperience({
  workExperience,
  setWorkExperience,
  emptyWorkExperience,
  updateArray,
  removeArrayItem,
}) {
  return (
    <section className="flex flex-col gap-3">
      <SectionTitle>Work Experience</SectionTitle>

      {workExperience.map((item, index) => (
        <div
          key={index}
          className="grid grid-cols-1 lg:grid-cols-5 gap-3 border p-3 rounded-md"
        >
          <Calendar
            value={dateValue(item.fromDate)}
            onChange={(e) =>
              updateArray(setWorkExperience, index, "fromDate", toIST(e.value))
            }
            showIcon
            dateFormat="dd/mm/yy"
            placeholder="From *"
            className="w-full bg-input border border-gray-300 rounded-md"
            inputClassName="w-full px-3 py-1.5 bg-input shadow-none focus:outline-none"
          />

          <Calendar
            value={dateValue(item.toDate)}
            onChange={(e) =>
              updateArray(setWorkExperience, index, "toDate", toIST(e.value))
            }
            showIcon
            dateFormat="dd/mm/yy"
            placeholder="To *"
            className="w-full bg-input border border-gray-300 rounded-md"
            inputClassName="w-full px-3 py-1.5 bg-input shadow-none focus:outline-none"
          />

          <InputText
            value={item.companyName}
            onChange={(e) =>
              updateArray(
                setWorkExperience,
                index,
                "companyName",
                e.target.value,
              )
            }
            placeholder="Company Name *"
            className="w-full px-3 py-1.5 border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
          />
          <InputText
            value={item.designation}
            onChange={(e) =>
              updateArray(
                setWorkExperience,
                index,
                "designation",
                e.target.value,
              )
            }
            placeholder="Designation *"
            className="w-full px-3 py-1.5 border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
          />
          <div className="flex gap-2">
            <InputText
              value={item.jobLocation}
              onChange={(e) =>
                updateArray(
                  setWorkExperience,
                  index,
                  "jobLocation",
                  e.target.value,
                )
              }
              placeholder="Job Location *"
              className="w-full px-3 py-1.5 border border-gray-300 rounded-md bg-input shadow-none focus:outline-none"
            />
            <Button
              type="button"
              variant="ghost"
              onClick={() => removeArrayItem(setWorkExperience, index)}
              className="max-w-10"
            >
              <Trash2 className="h-4 w-4 text-red-500" />
            </Button>
          </div>
        </div>
      ))}

      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() =>
          setWorkExperience((prev) => [...prev, { ...emptyWorkExperience }])
        }
        className="w-fit"
      >
        <Plus className="h-4 w-4 mr-1" />
        Add Work Experience
      </Button>
    </section>
  );
}

export default WorkExperience;
